// Kopfzeile mit Branding des einladenden Betriebs, Fortschritt und
// Speicherstatus ("Gespeichert" beruhigt: Abbrechen ist jederzeit möglich).

import { useDraft, useSyncStatus } from "../hooks.ts";
import { guideSteps, progress } from "../ablauf.ts";

export function Kopf() {
  const d = useDraft();
  const status = useSyncStatus();
  const p = progress(d.nav, guideSteps(d.rooms).length);
  const label =
    status.state === "gespeichert"
      ? "Gespeichert"
      : status.state === "offline"
        ? "Offline – wird später übertragen"
        : "Wird gespeichert …";
  return (
    <header className="kopf">
      <div className="kopf-row">
        {d.company.privat ? (
          <img className="logo logo-marke" src="/umzugsscan-logo.svg" alt="Umzugsscan" />
        ) : d.company.logoUrl ? (
          <img className="logo" src={d.company.logoUrl} alt={d.company.name} />
        ) : (
          <strong className="firma">{d.company.name}</strong>
        )}
        {/* Beta (23.10.2026): offener Test, einzelne Funktionen werden noch verbessert. */}
        <span className="kopf-rechts">
          <span className="beta" title="Umzugsscan ist in der Testphase; einzelne Funktionen werden noch verbessert.">Beta</span>
          {d.nav.screen !== "danke" && (
            <span className={`sync sync-${status.state}`} role="status">
              {label}
            </span>
          )}
        </span>
      </div>
      {d.nav.screen !== "danke" && (
        <div className="bar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(p * 100)}>
          <div style={{ width: `${Math.max(4, p * 100)}%` }} />
        </div>
      )}
    </header>
  );
}
